/* RESPONSIBLE TEAM: team-automation-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable promise/prefer-await-to-then */
/* eslint-disable ember/require-computed-property-dependencies */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr, belongsTo } from '@ember-data/model';
import { getOwner } from '@ember/application';
import { computed } from '@ember/object';
import { and, bool, equal, not, or, alias, readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { compare } from '@ember/utils';
import { copy } from 'ember-copy';
import { fragment } from 'ember-data-model-fragments/attributes';
import { get } from 'embercom/lib/ajax';
import nonconcurrentAjax from 'embercom/lib/nonconcurrent-ajax';
import {
  BUTTON_BOT_TYPE,
  CONVERSATION_STARTED_TARGET,
  customBotDeliveryChannels,
  INBOUND_BOT_TYPE,
  NO_TRIGGER_TARGET,
  OUTBOUND_BOT_TYPE,
  TRIGGERABLE_BOT_TYPE,
  USER_INACTIVITY_TARGET,
  ADMIN_INACTIVITY_TARGET,
  SLA_EVENT_TARGET,
  NEW_PHONE_CALL_TARGET,
  NEW_FIN_AGENT_API_CONVERSATION_TARGET,
  CONVERSATION_ASSIGNMENT_CHANGED_TARGET,
  AI_AGENT_WORKFLOW_TARGET,
  PHONE_REUSABLE_TARGET,
} from 'embercom/lib/operator/custom-bots/constants';
import Admin from 'embercom/models/admin';
import { objectTypes, states } from 'embercom/models/data/matching-system/matching-constants';
import MessageConstants from 'embercom/models/data/messages/message-constants';
import ContentDependency from 'embercom/models/matching-system/content-dependency';
import StateProperties from 'embercom/models/mixins/common/states/state-properties';
import Workflowable from 'embercom/models/mixins/operator/workflowable';
import buttonCustomBotEditConfigGenerator from 'embercom/objects/content-editor/configuration-generators/button-custom-bot';
import customBotEditConfigGenerator from 'embercom/objects/content-editor/configuration-generators/custom-bot';
import inboundCustomBotEditConfigGenerator from 'embercom/objects/content-editor/configuration-generators/inbound-custom-bot';
import triggerableCustomBotEditConfigGenerator from 'embercom/objects/content-editor/configuration-generators/triggerable-custom-bot';
import workflowEditConfigGenerator from 'embercom/objects/content-editor/configuration-generators/workflow';
import { CUSTOM_BOT_CONFIG_CLASSES } from 'embercom/objects/operator/configuration/configuration';
import Validations from 'embercom/validations/custom-bot';

export const COMPOSER_SUGGESTION_LAYOUT = 'composerSuggestionLayout';
export const CONVERSATION_LAYOUT = 'conversationLayout';

class RootWorkflow {
  dependency;
  targetChannels;

  constructor(json) {
    this.dependency = new ContentDependency(json);
    this.targetChannels = json.target_channels;
  }
}

export default Model.extend(Workflowable, Validations, StateProperties, {
  appService: service(),
  store: service(),
  intl: service(),
  finOptInService: service(),
  app: readOnly('appService.app'),
  availableTags: readOnly('app.tags.[]'),
  visualBuilderObject: belongsTo('operator/visual-builder/workflow', { async: false }),
  draftVisualBuilderObject: belongsTo('operator/visual-builder/workflow', { async: false }),
  intercomEventService: service(),
  workflowTitleEditor: service(),
  contentEditorService: service(),

  hasUnsavedChanges: or('hasDirtyAttributes', 'activeWorkflow.hasUnsavedChanges'),

  activeWorkflow: computed(
    'canUseDraftWorkflow',
    'draftVisualBuilderObject',
    'visualBuilderObject',
    'contentEditorService.isViewMode',
    function () {
      if (this.contentEditorService.isViewMode) {
        return this.visualBuilderObject;
      }

      if (this.canUseDraftWorkflow() && this.draftVisualBuilderObject) {
        return this.draftVisualBuilderObject;
      }

      return this.visualBuilderObject;
    },
  ),

  rollbackAttributes() {
    this._super(...arguments);
    this.activeWorkflow?.rollbackAttributes();
  },

  isCustomBot: true,
  autoSaveDisabled: true,
  config: computed('target', function () {
    if (!CUSTOM_BOT_CONFIG_CLASSES[this.target]) {
      throw new Error(
        `Cannot resolve path configuration class for custom bot target=${this.target}`,
      );
    }

    return new CUSTOM_BOT_CONFIG_CLASSES[this.target](this);
  }),

  editorConfig() {
    let container = getOwner(this);
    if (this.canUseVisualBuilderEditor) {
      return workflowEditConfigGenerator({ container, customBot: this });
    } else if (this.isInbound) {
      return inboundCustomBotEditConfigGenerator({ container, customBot: this });
    } else if (this.isButton) {
      return buttonCustomBotEditConfigGenerator({ container, customBot: this });
    } else if (this.isTriggerable) {
      return triggerableCustomBotEditConfigGenerator({ container, customBot: this });
    } else {
      return customBotEditConfigGenerator({ container, customBot: this });
    }
  },

  contentType: 'custom-bot',
  title: attr('string'),
  target: attr('string'),
  entityType: attr('number'),
  botData: fragment('operator/custom-bots/custom-bot-data'),
  order: attr('number'),
  state: attr('string'),
  showUntil: attr('string'),
  type: attr('string'),
  composerSuggestions: attr(),
  rulesetId: attr('number'),
  latestWorkflowInstanceId: attr('number'),

  editorLayout: computed('isInbound', function () {
    if (this.isInbound) {
      return COMPOSER_SUGGESTION_LAYOUT;
    } else {
      return CONVERSATION_LAYOUT;
    }
  }),

  triggerPredicateGroup: fragment('predicates/predicate-group'),

  isInbound: equal('type', INBOUND_BOT_TYPE),
  isOutbound: equal('type', OUTBOUND_BOT_TYPE),
  isButton: equal('type', BUTTON_BOT_TYPE),
  isTriggerable: equal('type', TRIGGERABLE_BOT_TYPE),

  canUseOmnichannel: computed('target', function () {
    return this.isTriggerable && !this.isNoTrigger;
  }),

  isNoTrigger: equal('target', NO_TRIGGER_TARGET),
  isFirstMessageTrigger: equal('target', CONVERSATION_STARTED_TARGET),
  isInactivityTrigger: computed('target', function () {
    return [USER_INACTIVITY_TARGET, ADMIN_INACTIVITY_TARGET].includes(this.target);
  }),
  isSlaBreachAdvanceWarningTrigger: equal('target', SLA_EVENT_TARGET),
  isPhoneCallTrigger: equal('target', NEW_PHONE_CALL_TARGET),
  isFinAgentApiConversationTrigger: equal('target', NEW_FIN_AGENT_API_CONVERSATION_TARGET),
  isPhoneReusableTrigger: equal('target', PHONE_REUSABLE_TARGET),
  isConversationAssignmentChangedTrigger: equal('target', CONVERSATION_ASSIGNMENT_CHANGED_TARGET),
  isAiAgentWorkflowTrigger: equal('target', AI_AGENT_WORKFLOW_TARGET),

  isInboundOrButton: or('isInbound', 'isButton'),
  isInboundOrButtonOrOutbound: or('isInbound', 'isButton', 'isOutbound'),

  templateId: attr('number'),
  lastUpdatedAt: attr('date'),
  lastUpdatedById: attr('number'),
  lastUpdatedBy: computed('lastUpdatedById', function () {
    return Admin.peekAndMaybeLoad(this.store, this.lastUpdatedById);
  }),

  hasTemplate: bool('templateId'),
  hasNoTemplate: not('hasTemplate'),

  isNewCustomBot: false,
  isNotNewCustomBot: not('isNewCustomBot'),

  isValid: or('isNotLive', 'validations.isValid'),
  isLive: equal('state', 'live'),
  isStopped: equal('state', 'stopped'),
  isDraft: equal('state', 'draft'),
  notDraft: not('isDraft'),
  canSave: and('isValid', 'isNotUploading'),
  canActivate: computed(
    'validations.isValid',
    'isNotUploading',
    'draftVisualBuilderObject.validations.isValid',
    'canUseDraftWorkflow',
    'isInbound',
    function () {
      if (
        this.isInbound &&
        this.canUseWorkflowDraftStateForInbound() &&
        this.draftVisualBuilderObject
      ) {
        return this.draftVisualBuilderObject.validations.isValid && this.isNotUploading;
      }
      // For other workflow types (AI Agent, Reusable), check draft validations normally
      if (!this.isInbound && this.canUseDraftWorkflow() && this.draftVisualBuilderObject) {
        return this.draftVisualBuilderObject.validations.isValid && this.isNotUploading;
      }
      // Default: check regular validations
      return this.validations.isValid && this.isNotUploading;
    },
  ),
  canUseVisualBuilderEditor: computed('paths.length', 'activeWorkflow', function () {
    return !this.paths.length && this.activeWorkflow;
  }),
  validLocalVariableIdentifiersUsedInWorkflow: readOnly(
    'activeWorkflow.validations.attrs.localVariablesExist.isValid',
  ),

  shouldShowOptInCopyForAiAnswers: computed('useAiAnswers', function () {
    return (
      this.useAiAnswers &&
      this.finOptInService.bypassFinOptInModal &&
      !this.finOptInService.hasOptedInToFin
    );
  }),
  useAiAnswers: readOnly('visualBuilderObject.useAiAnswers'),
  useAiCategorization: readOnly('visualBuilderObject.useAiCategorization'),

  previewDisabledMessage: computed('intl.locale', 'canActivate', 'hasUnsavedChanges', function () {
    if (!this.canActivate) {
      return this.intl.t('operator.custom-bot.editor.header.errors-in-bot', {
        isAiAgentWorkflowTrigger: this.isAiAgentWorkflowTrigger,
      });
    }
    if (this.hasUnsavedChanges) {
      return this.intl.t('operator.custom-bot.editor.header.please-save');
    }

    if (this.visualBuilderObject?.isCustomerFacing === false) {
      return this.intl.t('operator.custom-bot.editor.header.cannot-preview-background');
    }
  }),

  canPreview: not('previewDisabledMessage'),

  preferredDevices: attr('array'),
  targetChannels: attr('array'),

  deliveryChannel: computed('preferredDevices.[]', function () {
    return customBotDeliveryChannels.find((channel) => {
      return compare(channel.preferredDevices.sort(), this.preferredDevices.sort()) === 0;
    });
  }),

  validationKeys: ['validations.attrs.paths', 'validations.attrs.firstPathConstraints'],

  validationMessages: computed(
    'intl.locale',
    'validations.messages.[]',
    'customBot.isUploading',
    function () {
      let errorMessages = [];
      let validationKeys = this.validationKeys;
      if (this.get('customBot.isUploading')) {
        errorMessages.push(this.intl.t('operator.custom-bot.editor.header.upload-error-message'));
      }

      validationKeys.forEach((validationKey) => {
        if (this.get(`${validationKey}.isInvalid`)) {
          let message = this._formatValidationMessages(
            validationKey,
            this.get(`${validationKey}.messages`),
          );
          errorMessages.push(message);
        }
      });

      return errorMessages.flat();
    },
  ),

  validationFailureMessage: computed('validationMessages.[]', function () {
    return this.validationMessages.join('. ');
  }),

  previewConfiguration: computed(
    'analyticsEventObjectLabel',
    'intersectionPreviewMode',
    'composerSuggestions',
    'title',
    function () {
      return {
        previewTitle: this.title,
        intersectionMode: this.intersectionPreviewMode,
        analyticsEventObjectLabel: this.analyticsEventObjectLabel,
        composerSuggestions: this.getComposerSuggestions(),
      };
    },
  ),

  intersectionPreviewMode: computed('isInbound', function () {
    if (this.isInbound) {
      return 'inbound-custom-bot';
    } else {
      return 'outbound-custom-bot';
    }
  }),

  analyticsData: computed('id', 'isNewCustomBot', 'firstStep.id', function () {
    return {
      object: 'bot-auto-message',
      context: this.isNewCustomBot ? 'new-workflow' : 'existing-workflow',
      custom_bot_id: this.id,
      workflow_first_step_id: this.get('firstStep.id'),
    };
  }),

  analyticsEventObjectLabel: computed('target', 'isInbound', function () {
    if (this.target === 'everyone') {
      return 'custom_bot_bob';
    } else if (this.target === 'user') {
      return this.isInbound ? 'custom_bot_user_inbound' : 'custom_bot_user_outbound';
    } else if (this.target === 'no-trigger' || this.target === 'conversation-started') {
      return 'custom_bot_triggerable';
    } else {
      return this.isInbound ? 'custom_bot_visitor_inbound' : 'custom_bot_visitor_outbound';
    }
  }),

  allowedUserRoles: computed(
    'isPhoneCallTrigger',
    'isTriggerable',
    'isFinAgentApiConversationTrigger',
    function () {
      if (this.isFinAgentApiConversationTrigger) {
        return ['user'];
      } else if (this.isPhoneCallTrigger || this.isTriggerable) {
        return ['user', 'lead'];
      } else {
        return ['user', 'lead', 'visitor'];
      }
    },
  ),

  messageVariationForMessengerPreview: computed(
    'lastStep.controls.[]',
    'firstStep.blocks.[]',
    function () {
      let messageVariation = this.store.createRecord('message-variation');
      let replyOptions = this.get('lastStep.controls').mapBy('buttonLabel');
      messageVariation.setProperties({
        blocks: copy(this.get('firstStep.blocks')),
        from: this.get('app.operatorBot'),
        isInApp: true,
        messageStyle: MessageConstants.chat,
        replyOptions,
      });
      return messageVariation;
    },
  ),

  compatibleChannels: readOnly('visualBuilderObject.supportedChannels', function () {
    return this.visualBuilderObject.supportedChannels;
  }),

  inactivityDuration: alias('botData.inactivityDuration'),

  slaTargetType: alias('botData.slaTargetType'),
  delayInSeconds: alias('botData.delayInSeconds'),

  get slaTargetTypeLabel() {
    switch (this.slaTargetType) {
      case 'first_reply_time':
        return this.intl.t(
          'operator.custom-bot.trigger.before-sla-breach.target-type.first-reply-time',
        );
      case 'next_reply_time':
        return this.intl.t(
          'operator.custom-bot.trigger.before-sla-breach.target-type.next-reply-time',
        );
      case 'resolution_time':
        return this.intl.t(
          'operator.custom-bot.trigger.before-sla-breach.target-type.time-to-resolve',
        );
      case 'time_to_close':
        return this.intl.t(
          'operator.custom-bot.trigger.before-sla-breach.target-type.time-to-close',
        );
      default:
        return '';
    }
  },

  description: attr('string'),

  matchPercentage: alias('botData.matchPercentage'),

  showFinStepReachedStat: computed('isAiAgentWorkflowTrigger', function () {
    return (
      !this.isAiAgentWorkflowTrigger &&
      this.app.canUseFeature('rd-services-view-fin-involvement-stat')
    );
  }),

  canMigrateToProcedure: attr('boolean'),

  createdFromStandaloneApp: alias('botData.createdFromStandaloneApp'),

  _formatValidationMessages(key, messages) {
    if (key.includes('paths') || key.includes('firstPathConstraints')) {
      return this.intl.toString('operator.custom-bot.editor.header.finish-designing');
    }

    if (key.includes('messengerTrigger')) {
      return this.intl.t('operator.custom-bot.editor.header.select-to-launch');
    }

    return messages;
  },

  getComposerSuggestions() {
    if (!this.composerSuggestions) {
      return null;
    }
    return this.composerSuggestions;
  },

  getFinStepCount() {
    return this.visualBuilderObject.groups.reduce((acc, group) => {
      return (
        acc + group.steps.filter((step) => step.type === 'operator/visual-builder/step/fin').length
      );
    }, 0);
  },

  getStepCount() {
    if (this.canUseDraftWorkflow() && this.draftVisualBuilderObject) {
      return this.draftVisualBuilderObject.groups.reduce((acc, group) => {
        return acc + group.steps.length;
      }, 0);
    } else {
      return this.visualBuilderObject.groups.reduce((acc, group) => {
        return acc + group.steps.length;
      }, 0);
    }
  },

  canUseDraftWorkflow() {
    return (
      this.app?.canUseFeature('workflow-draft-state') &&
      (this.isAiAgentWorkflowTrigger ||
        this.isNoTrigger ||
        this.canUseWorkflowDraftStateForInbound())
    );
  },

  canUseWorkflowDraftStateForInbound() {
    return this.isInbound;
  },

  beforeSave() {
    this.paths.invoke('ensureStepsAreLinkedCorrectly');

    if (this.rulesetId) {
      if (this.canUseDraftWorkflow()) {
        this.title = this.activeWorkflow.additionalData.title ?? '';
        this.ruleset.clientData.title = this.title;
      } else {
        this.title = this.ruleset?.clientData?.title ?? '';
      }
    }

    if (this.canUseDraftWorkflow() && this.draftVisualBuilderObject) {
      this.set('visualBuilderObject', this.draftVisualBuilderObject);
      // Set the custom bot workflow details to the active workflow
      this.set('description', this.draftVisualBuilderObject.additionalData.description);
      this.set('targetChannels', this.draftVisualBuilderObject.additionalData.targetChannels);
      this.set('preferredDevices', this.draftVisualBuilderObject.additionalData.preferredDevices);
      this.set('botData', copy(this.draftVisualBuilderObject.additionalData.customBotData));

      // Copy audience targeting data from draft to ruleset
      if (this.ruleset && !this.ruleset.isDeleted && this.canUseWorkflowDraftStateForInbound()) {
        this.ruleset.set('segmentIds', this.draftVisualBuilderObject.additionalData.segmentIds);

        // Ensure predicateGroup exists (copy from draft or create empty)
        if (this.draftVisualBuilderObject.additionalData.predicateGroup) {
          this.ruleset.set(
            'predicateGroup',
            copy(this.draftVisualBuilderObject.additionalData.predicateGroup),
          );
        } else if (!this.ruleset.predicateGroup) {
          this.ruleset.set(
            'predicateGroup',
            this.store.createFragment('predicates/predicate-group'),
          );
        }

        // Ensure rolePredicateGroup exists (copy from draft or create empty)
        if (this.draftVisualBuilderObject.additionalData.rolePredicateGroup) {
          this.ruleset.set(
            'rolePredicateGroup',
            copy(this.draftVisualBuilderObject.additionalData.rolePredicateGroup),
          );
        } else if (!this.ruleset.rolePredicateGroup) {
          this.ruleset.set(
            'rolePredicateGroup',
            this.store.createFragment('predicates/predicate-group'),
          );
        }

        // Ensure clientPredicateGroup exists (copy from draft or create empty)
        if (this.draftVisualBuilderObject.additionalData.clientPredicateGroup) {
          this.ruleset.set(
            'clientPredicateGroup',
            copy(this.draftVisualBuilderObject.additionalData.clientPredicateGroup),
          );
        } else if (!this.ruleset.clientPredicateGroup) {
          this.ruleset.set(
            'clientPredicateGroup',
            this.store.createFragment('predicates/predicate-group'),
          );
        }
      }
    }
  },

  afterSave() {
    // Adding in try catch as don't want to possibly interrupt the after save process
    try {
      if (this.hasUnsavedChanges) {
        // For some reason, the model dirty state is not reset after setting live.
        // A workaround to reset the unsaved changes after setting the workflow live.
        // This is not an ideal solution and will need to be refactored.
        this.rollbackAttributes();
      }

      this.visualBuilderObject.groups.forEach((group) => {
        group.steps.forEach((step) => {
          if (step.type === 'operator/visual-builder/step/fin') {
            this.intercomEventService.trackAnalyticsEvent({
              object: 'custom_bot_fin_steps',
              action: 'saved',
              ruleset_id: this.rulesetId,
              custom_bot_id: this.id,
              custom_bot_type: this.type,
              external_step_id: step.externalStepId,
              step_id: step.id,
              layout_column_index: group.layoutColumnIndex,
              use_ai_answers: step.useAiAnswers,
              use_custom_answers: step.useCustomAnswers,
              custom_answer_count: step.customAnswerCount,
              csat_enabled_for_hard_resolution: step.csatEnabledForHardResolution,
              csat_enabled_for_soft_resolution: step.csatEnabledForSoftResolution,
              use_inactivity_settings: step.useInactivitySettings,
              inactivity_duration: step.inactivityDuration,
              pre_handover_answer_enabled: step.preHandoverAnswerEnabled,
              follow_up_type: step.followUpType,
            });
          }
        });
      });
    } catch (error) {
      console.error('Error tracking custom bot fin step event:', error);
    }
  },

  activate() {
    return this._post(`/ember/operator_custom_bots/${this.id}/activate`).then((response) => {
      this._pushPayloadToStore(response);
    });
  },

  deactivate() {
    return this._post(`/ember/operator_custom_bots/${this.id}/deactivate`).then((response) => {
      this._pushPayloadToStore(response);
    });
  },

  async loadDependentObjects() {
    if (this.isNoTrigger) {
      let dependencies = await get(`/ember/operator_custom_bots/${this.id}/dependent_objects`, {
        app_id: this.get('app.id'),
      });

      return dependencies.map((dependency) => {
        return new ContentDependency({
          entity_id: dependency.id,
          entity_type: objectTypes.triggerableCustomBot,
          title: dependency.title,
          ruleset_id: dependency.ruleset_id,
          state: dependency.live ? states.live : states.draft, // we only need values for 'live' and 'not live'
        });
      });
    }
    return [];
  },

  async loadRootWorkflows() {
    if (this.isNoTrigger) {
      let rootWorkflows = await get(`/ember/operator_workflows/root_workflows`, {
        app_id: this.get('app.id'),
        entity_type: objectTypes.triggerableCustomBot,
        entity_id: this.id,
      });

      return rootWorkflows.map((workflow) => {
        return new RootWorkflow(workflow);
      });
    }
    return [];
  },

  async loadUserVisibilityChangingBots() {
    if (this.isNoTrigger) {
      let userVisibilityChangingBots = await get(
        `/ember/operator_custom_bots/${this.id}/user_visibility_changing_bots`,
        {
          app_id: this.get('app.id'),
          user_visible: !!this.visualBuilderObject?.isCustomerFacing,
        },
      );

      return userVisibilityChangingBots;
    }
    return [];
  },

  _post(url, additionalData = {}) {
    return this._request(url, 'POST', additionalData);
  },

  _request(url, requestType = 'POST', additionalData = {}) {
    let data = Object.assign(additionalData, {
      id: this.id,
      app_id: this.get('app.id'),
      admin_id: this.get('app.currentAdmin.id'),
    });
    if (requestType === 'POST') {
      data = JSON.stringify(data);
    }
    return nonconcurrentAjax(this, {
      url,
      type: requestType,
      data,
    });
  },

  saveAsDraft() {
    let currentWorkflow = this.draftVisualBuilderObject;

    if (!currentWorkflow) {
      throw new Error('No workflow found for save as draft');
    }

    let serializedWorkflow = currentWorkflow.serialize({
      excludeLocalizations: true,
    });

    let saveData = {
      visual_builder_object: serializedWorkflow,
    };

    return this._post(`/ember/operator_custom_bots/${this.id}/save_as_draft`, saveData).then(
      (response) => {
        this.workflowTitleEditor.resetHasChanged();

        // Reset the hasBeenEdited flag on the draft workflow after successful save
        if (this.draftVisualBuilderObject) {
          this.draftVisualBuilderObject.hasBeenEdited = false;
        }

        // When no draft existed, both visualBuilderObject and draftVisualBuilderObject referenced the same model instance.
        // As a result, modifications were applied to visualBuilderObject but not persisted.
        // After the first draft was saved, visualBuilderObject and draftVisualBuilderObject began referencing separate object.
        // However, the earlier modifications to visualBuilderObject remained in memory.
        // This caused the view mode to display the draft content.
        // Hence, we need to rollback the visualBuilderObject.
        this.visualBuilderObject.rollbackAttributes();

        // Push the updated custom bot data to the store, similar to activate/deactivate
        this._pushPayloadToStore(response);

        return response;
      },
    );
  },

  discardDraft() {
    this.visualBuilderObject.rollbackAttributes();
    this.draftVisualBuilderObject.rollbackAttributes();
    return this._post(`/ember/operator_custom_bots/${this.id}/discard_draft`).then(() => {
      this.workflowTitleEditor.initialize(this.title);
    });
  },

  get ruleset() {
    if (!this.rulesetId) {
      return null;
    }

    return this.store.peekRecord('matching-system/ruleset', this.rulesetId);
  },

  _pushPayloadToStore(response) {
    let serializer = this.store.serializerFor('operator/custom-bot');
    let model = this.store.modelFor('operator/custom-bot');
    let serializedResponse = serializer.normalize(model, response);
    serializedResponse.id = response.id;
    this.store.push(serializedResponse);

    // Fix: After pushing, Ember Data may mark embedded attribute descriptors as deleted
    // when the workflow ID changes. Revive them by transitioning to 'loaded.saved' state.
    let updatedBot = this.store.peekRecord('operator/custom-bot', response.id);
    if (updatedBot?.draftVisualBuilderObject) {
      updatedBot.draftVisualBuilderObject.attributeDescriptors.forEach((descriptor) => {
        if (descriptor.isDeleted) {
          // eslint-disable-next-line ember/no-private-routing-service
          descriptor._internalModel.transitionTo('loaded.saved');
        }
      });
    }
  },
});
